import { z } from "zod";

/**
 * HCA Moravia — globální vyhledávač v horní liště dashboardu.
 * Dotaz se trimuje; minimum 2 znaky, ať se neprohledává na každé písmeno.
 */
export const globalSearchSchema = z.object({
  q: z.string().trim().min(2, "Zadejte alespoň 2 znaky").max(100),
});

export type GlobalSearchInput = z.infer<typeof globalSearchSchema>;
